<template>
  <div v-if="open" :class="[bem.b(), rootClass]" :style="rootStyle">
    <a-spin :spinning="fullLoading" :wrapper-class-name="bem.e('content')">
      <!-- 头部区 -->
      <div :class="bem.e('header')">
        <!-- 关闭按钮 -->
        <div
          v-if="showClose"
          :class="[bem.e('close'), mediaClass]"
          :style="closeStyle"
        >
          <div class="close-content" @click="close">
            <slot name="closeIcon">
              <ll-icon
                v-bind="closeIcon"
                :icon-name="closeIcon.iconName || 'icon-return-arrow'"
                :style="{ marginRight: closeIconTextSpace + 'px' }"
              />
            </slot>
            <div class="close-text">
              <slot name="closeText">
                <span
                  :style="{
                    'font-size': closeTextSize + 'px',
                    color: closeTextColor,
                  }"
                >
                  {{ closeText }}
                </span>
              </slot>
            </div>
          </div>
        </div>

        <!-- 头部标题插槽 -->
        <div
          v-if="showHeader"
          :style="headerStyle"
          :class="['header-content', mediaClass]"
        >
          <slot name="header"></slot>
        </div>
      </div>

      <!-- 主内容区 -->
      <a-spin
        :spinning="mainLoading"
        :wrapper-class-name="bem.e('main-loading')"
      >
        <div
          ref="scrollRef"
          :class="[
            bem.e('main'),
            isBespreadMain ? 'bespread-main' : '',
            mainClass,
          ]"
          :style="mainStyle"
        >
          <div :class="['main-content', mediaClass]">
            <!-- 主内容区域插槽 -->
            <slot name="main"></slot>
          </div>
        </div>
      </a-spin>

      <!-- 页脚 -->
      <div
        v-if="showFooter"
        :class="[
          bem.e('footer'),
          isShowContentBottomBox ? bem.is('shadow') : '',
        ]"
        :style="footerStyle"
      >
        <div :class="['footer-content', mediaClass]">
          <!-- 页脚区域插槽 -->
          <slot name="footer"></slot>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script lang="ts" setup>
import { useScroll } from '@ll-plus/hooks'
import { createNamespace } from '@ll-plus/utils'
import { computed } from 'vue'
import { modalOverlayEmits, modalOverlayProps } from './modal-overlay'

defineOptions({ name: 'LlModalOverlay' })

const props = defineProps(modalOverlayProps)
const emits = defineEmits(modalOverlayEmits)

const bem = createNamespace('modal-overlay')

const { scrollPosition, isHasScrollBar, scrollRef } = useScroll()

const isShowContentBottomBox = computed(() => {
  // 如果顶部的阴影为true则说明是内部的容器在滚动产品的阴影 则由容器的滚动情况来决定阴影
  if (props.footerShadowPlacement === 'inner') {
    return (
      props.isShowFooterShadow &&
      isHasScrollBar.value &&
      scrollPosition.value !== 'bottom'
    )
  } else {
    // 如果顶部的阴影为false，则说明不是内部容器滚动，则底部的阴影由 外部的isShowFooterShadow来决定
    return props.isShowFooterShadow
  }
})

// 添加滚动到顶部的方法
const scrollToTop = () => {
  if (scrollRef.value) {
    scrollRef.value.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
}

const close = () => {
  emits('close', false)
  emits('update:open', false)
}

const rootStyle = computed(() => ({
  zIndex: props.zIndex,
  borderRadius: props.borderRadius,
}))

defineExpose({
  scrollToTop,
})
</script>
